var $ = require('jQuery');
var Storage = require('../storage.js');

/**
 * Tab library to help manage the various interactions for tabs.
 */
module.exports = function() {
  var self = this;

  // Store the name of the active tab in a cookie
  var createActiveTabCookie = function (tabName) {
    var storage = new Storage();
    storage.createCookie('active_tab', tabName, 1);
  };

  var removeActiveTabCookie = function () {
    var storage = new Storage();
    storage.createCookie('active_tab', null, -1);
  };

  // Removes 'tab=tab.view.name' from http params and also cleans up trailing '?' if needed
  var removeActiveTabReferenceFromUrl = function () {
    // `keyword` occurrence in the url means it's a search filter, don't remove the `tab` part.
    if (window.location.href.indexOf('tab=') !== -1 && window.location.href.indexOf('keywords=') === -1) {

      // Url with Regex101 tests: https://regex101.com/r/6sw44p/2
      var newUrl = window.location.href.replace(/([?&])(tab=[^\\&=]*)/i, '$1');
      if (newUrl.endsWith('?')) {
        newUrl = newUrl.slice(0, -1);
      }

      window.history.replaceState({}, document.title, newUrl);
    }
  };

  // Sets the active tab
  this.setActive = function (tab) {
    var parent = $(tab).parent();

    if (this.getStyle() == 'wizard') {
      $('.tabs li').addClass('disabled').removeClass('active');  // deactivate all tabs
      parent.addClass('active').removeClass('disabled');
    }
    else {
      $('.tabs li').removeClass('active');
      parent.addClass('active');
      $(document).trigger('tab.activated', $(parent).attr('id'));
    }

    $('.tab-content').removeClass('active');                     // activate selected tab
    $('#' + parent.attr('id') + 'Content').addClass('active');   // activate tab content

    createActiveTabCookie(parent.data('tab'));

    removeActiveTabReferenceFromUrl();
  };

  // Activate the requested tab
  this.click = function (e) {
    var parent = $(this).parent();

    e.preventDefault();

    if (parent.hasClass('disabled')) {
      return;
    }

    self.setActive(this);

    $('body').trigger('tabchange', [this]);
  };

  // Same as click, but simply cycles through to the next tab
  this.next = function () {
    var tab = $('.tabs li.active');
    var next = tab.next().find('a');

    if (next.length) {
      self.setActive(next);
    }
  };

  // Returns the type for the tab system on this page
  this.getStyle = function() {
    return $('.tabular-system').data('type');
  };

  // Checks to see if there is another tab to move to
  this.hasNext = function () {
    var tab = $('.tabs li.active');
    var next = tab.next().find('a');

    return next.length;
  };

  // Invokes specific tab, if the slug is provided via the url.
  // Uses the native getElementById method that can safely accept malformed ids without throwing a SyntaxError.
  this.checkHashTab = function () {
    var hash = window.location.hash;
    var tab = document.getElementById(hash.replace('#', '')+'-Tab');
    var tabLink;

    if (!tab) {
      return;
    }

    tabLink = $(tab).find('a');

    if (tabLink.length > 0) {
      tabLink.click();
    }
  };

  // When we initialise tabular let's setup our tab bindings
  $('body').on('click', '.tabs:not(.ignore) li a', this.click);
  $('body').on('click', '.next-tab', this.click);

  checkHashTab();

  // Remove active tab cookie on page reloads
  $(document).on('ready', function() {
    if ($.pjax.options === undefined) {
      removeActiveTabCookie();
    }
  });

  removeActiveTabReferenceFromUrl();
  $(document).on('ready pjax:success', function() {
    removeActiveTabReferenceFromUrl();
  });

};
